import { useState } from 'react';
import { Input, Select, Tag } from 'antd';
import { useCountryArray } from '../../../../utils/countryArray';
import { createPhoneNumberFieldConfig } from '../../../../utils/formFields/phoneNumberField';
import { useCountryCodeInfos } from '../../../owners/form/utils/useCountryCodeInfos';

const { Option } = Select;

export const useGroomersFields = ({ form, country, setCountry } = {}) => {
  const countries = useCountryArray();
  const { handleCountryCodeInfos } = useCountryCodeInfos(country);

  const [cityOptions, setCityOptions] = useState([]);

  const filterOption = (input, option) =>
    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const groomersFields = [
    {
      name: ['name']
    },
    {
      name: ['address', 'number'],
      input: <Input type="number" />
    },
    {
      name: ['address', 'street']
    },
    {
      label: 'address.country',
      name: ['address', 'country'],
      input: (
        <Select
          showSearch
          filterOption={filterOption}
          onChange={(value) => {
            if (setCountry) setCountry(value);
            if (form) {
              form.setFieldValue(['address', 'postal_code'], undefined);
              form.setFieldValue(['address', 'city'], undefined);
            }
            setCityOptions([]);
          }}
        >
          {(countries || []).map((c) => (
            <Option key={c} value={c}>
              <Tag>{c}</Tag>
            </Option>
          ))}
        </Select>
      )
    },
    {
      name: ['address', 'postal_code'],
      input: (
        <Input
          type="number"
          onChange={(e) => {
            const postalCode = e.target.value;

            if (form) {
              form.setFieldValue(['address', 'city'], undefined);
            }
            setCityOptions([]);

            if (postalCode.length < 5) return;

            handleCountryCodeInfos(postalCode).then(({ cities, city }) => {
              if (cities.length > 1) {
                setCityOptions(cities);
              } else {
                if (form) {
                  form.setFieldValue(['address', 'city'], city || undefined);
                }
                setCityOptions([]);
              }
            });
          }}
        />
      )
    },
    {
      name: ['address', 'city'],
      input:
        cityOptions.length > 1 ? (
          <Select
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {cityOptions.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        ) : (
          <Input />
        )
    },
    createPhoneNumberFieldConfig('phone_number')
  ];

  return { groomersFields };
};
